import { Company } from 'types/api/rbac/company'
import { UserAuthCompany } from 'types/api/user/session'
import { keysToSnakeCase } from 'utils/obj'

export function getCompanyName(company: UserAuthCompany): string {
  return company?.alias ?? company?.name
}

export function getMappedCompanyData(companyData) {
  // todo: EN-6511 - this check and remapping is for backwards compatibility.
  // once entitlements are migrated, we can decide if we want to use the camel cased version of the properties
  if (Array.isArray(companyData)) {
    return companyData[0] as Company
  }

  const { entitlements, ...rest } = companyData

  return {
    ...keysToSnakeCase(rest),
    entitlements
  } as Company
}
